<template>
  <!-- Modal overlay that closes the modal when clicked -->
  <div class="modal-overlay" @click="closeModal">
    <!-- Modal content; stop click propagation -->
    <div class="modal-content" @click.stop>
      <!-- 'X' Close button at the top-right corner -->
      <button class="close-button" @click="closeModal">&times;</button>

      <!-- Title for the modal content -->
      <h2 class="modal-title">About the Project</h2>

      <!-- Slot for modal content -->
      <div class="modal-text">
        <slot>
          The Soil Viewer project, developed by the Soil Science Artificial Intelligence Lab at University of Florida, 
          is an innovative platform designed to make soil maps accessible, dynamic, and user-friendly. It combines cutting-edge 
          Earth Observation data, machine learning models, and intuitive tools to deliver high-resolution soil-related information. 
          Users can interact with the Soil Viewer to search, locate, and download customized maps for their areas of interest. 
          With its modular design, the system can easily integrate additional geospatial products, and soil indicators, ensuring 
          adaptability for future needs. Whether you're a farmer, researcher, or policymaker, the Soil Viewer provides timely, 
          actionable insights to support sustainable agriculture, precision land management, and ecosystem monitoring.
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits } from 'vue';

const emit = defineEmits(['close']);

const closeModal = () => {
  // Emit an event to inform the parent to close the modal
  emit('close');
};
</script>

<style scoped>
/* Modal overlay to cover the entire screen */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it's on top of other content */
}

/* Modal content box */
.modal-content {
  background: white;
  padding: 40px 30px; /* Increased padding for more white space */
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  max-width: 600px; /* Restrict width */
  width: 90%;
  position: relative; /* For positioning the close button */
  text-align: left;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

/* Title for the modal */
.modal-title {
  font-family: 'Courier', monospace;
  font-size: 1.5rem;
  font-weight: bold;
  color: #14213d; /* Updated title text color */
  margin-bottom: 15px; /* Add space below the title */
  text-align: center; /* Center align the title */
}

/* Slot text styling - using Courier font */
.modal-text {
  font-family: 'Courier', monospace;
  color: #333; /* Default text color */
  white-space: pre-wrap; /* Preserve formatting and line breaks */
  line-height: 1.5;
  font-size: 1rem;
  text-align: justify; /* Fully align the text */
}

/* 'X' button in the top-right corner */
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  line-height: 1;
}

.close-button:hover {
  color: #000; /* Slightly darker when hovered */
}
</style>
